(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[150],{

/***/ 3010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ LegalMdx; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next-mdx-remote/index.js + 3 modules
var next_mdx_remote = __webpack_require__(2154);
// EXTERNAL MODULE: ./components/molecules/Mdx/components.tsx + 4 modules
var components = __webpack_require__(9998);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(2269);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
// EXTERNAL MODULE: ../../packages/design-system/mdx/wrapper/src/styles.ts
var styles = __webpack_require__(2351);
;// CONCATENATED MODULE: ../../packages/design-system/mdx/legal/src/styles.ts


var TOP_MARGIN = (0,styled_components_browser_esm/* css */.iv)(["", ""], {
  "paddingTop": "1.25rem"
});
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "sc-16bytm9-0"
})(["", " ol,ul{li{", "}pre{", " ", "}}ol.alphabetic > li:before,ol > li > ol > li > ol > li:before{font-weight:bold;display:table-cell;width:2.6rem;content:'(' counter(item,lower-alpha) ')';}ol{", " list-style-type:none;counter-reset:item;li p:not(:first-child){", "}ol{list-style-type:none;counter-reset:item;}> li{display:table;counter-increment:item;}> li:before,> li > ol > li:before{font-weight:bold;display:table-cell;width:2.6rem;}> li:before{content:counters(item,'.') '.';}> li > ol > li:before{content:counters(item,'.');}li ol{", "}li ol > li{margin:0;display:table;}}> ol > li:first-of-type{", "}ul{list-style-type:circle;}pre,code{", "}table{th{", "}th,td{", "}tr{td{", "}th{", "}td:not(:first-child),th:not(:first-child){", "}}}", ""], styles/* BASE_MDX_WRAPPER_STYLES */.D, TOP_MARGIN, TOP_MARGIN, {
  "paddingLeft": "2rem"
}, {
  "listStyleType": "decimal",
  "paddingLeft": "0px !important"
}, TOP_MARGIN, {
  "paddingLeft": "0px !important"
}, {
  "paddingTop": "0px"
}, {
  "fontFamily": "Sarabun, sans-serif"
}, {
  "whiteSpace": "nowrap",
  "textAlign": "start"
}, {
  "padding": "1rem"
}, {
  "borderTopWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(65 205 127 / var(--tw-border-opacity))",
  "verticalAlign": "top"
}, {
  "verticalAlign": "top"
}, {
  "borderLeftWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(65 205 127 / var(--tw-border-opacity))"
}, function (_ref) {
  var styles = _ref.styles;
  return styles !== null && styles !== void 0 ? styles : '';
});
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../packages/design-system/mdx/legal/src/index.tsx


var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





/*
  This component should be used to wrap a markdown-rendering component that will
  render legal content. It formats legal nested bullet-ing correctly:
  (1,2,3... --> 1.1,1.2,1.3... --> (a),(b),(c)...)
 */
var LegalMdxWrapper = function LegalMdxWrapper(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, _objectSpread(_objectSpread({}, rest), {}, {
    children: children
  }));
};

/* harmony default export */ var src = (LegalMdxWrapper);
;// CONCATENATED MODULE: ../../packages/design-system/mdx/legal/index.ts

/* harmony default export */ var legal = (src);
// EXTERNAL MODULE: ./components/molecules/Mdx/styled.tsx
var styled = __webpack_require__(3649);
;// CONCATENATED MODULE: ./components/molecules/Mdx/LegalMdx/index.tsx


function LegalMdx_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LegalMdx_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LegalMdx_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LegalMdx_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var LegalMdx = function LegalMdx(_ref) {
  var mdx = _ref.mdx;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(legal, {
    styles: styled/* WWW_MDX_OVERRIDE_STYLES */.r,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(next_mdx_remote/* MDXRemote */.R, LegalMdx_objectSpread(LegalMdx_objectSpread({}, mdx), {}, {
      components: components/* components */.w
    }))
  });
};

/***/ }),

/***/ 9998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ components; }
});

// EXTERNAL MODULE: ./components/molecules/Mdx/styled.tsx
var styled = __webpack_require__(3649);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
;// CONCATENATED MODULE: ./components/molecules/ContentBanner/styled.tsx

var BannerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__BannerWrapper",
  componentId: "sc-1pasw04-0"
})(["", ""], {
  "display": "grid",
  "gridTemplateColumns": "repeat(1, minmax(0, 1fr))",
  "gridTemplateRows": "repeat(1, minmax(0, 1fr))"
});
var BannerTextContent = styled_components_browser_esm/* default.aside.withConfig */.ZP.aside.withConfig({
  displayName: "styled__BannerTextContent",
  componentId: "sc-1pasw04-1"
})(["", " ", " ", " ", " a{", "}"], {
  "alignSelf": "center",
  "gridColumn": "1 / span 1",
  "gridRow": "1 / span 1"
}, {
  "marginLeft": "auto",
  "marginRight": "auto",
  "width": "100%",
  "maxWidth": "56rem",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "@media (min-width: 1280px)": {
    "maxWidth": "48rem"
  },
  "@media (min-width: 1536px)": {
    "maxWidth": "56rem"
  }
}, {
  "marginLeft": "auto",
  "marginRight": "auto",
  "width": "100%",
  "fontSize": "1.5rem",
  "lineHeight": "1.5",
  "@media (min-width: 768px)": {
    "fontSize": "2rem"
  },
  "@media (min-width: 1280px)": {
    "fontSize": "2.25rem"
  },
  "@media (min-width: 1536px)": {
    "lineHeight": "1.625",
    "fontSize": "2.65rem"
  }
}, {
  "paddingTop": "1.5rem",
  "paddingBottom": "1.5rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "fontFamily": "Lora"
}, {
  "--tw-text-opacity": "1 !important",
  "color": "rgb(255 196 37 / var(--tw-text-opacity)) !important",
  "textDecorationLine": "underline"
});
var BannerBackground = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "styled__BannerBackground",
  componentId: "sc-1pasw04-2"
})(["", ""], {
  "height": "100%",
  "width": "100%",
  "gridColumn": "1 / span 1",
  "gridRow": "1 / span 1"
});
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/molecules/ContentBanner/index.tsx




var ContentBanner = function ContentBanner(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(BannerWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BannerBackground, {
      alt: '',
      src: '/images/roughstock/banner-bg.png'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BannerTextContent, {
      children: children
    })]
  });
};
;// CONCATENATED MODULE: ./components/molecules/PdfViewer/styled.tsx

var FormattedEmbed = styled_components_browser_esm/* default.embed.withConfig */.ZP.embed.withConfig({
  displayName: "styled__FormattedEmbed",
  componentId: "sc-1tzrh5e-0"
})(["", ""], {
  "display": "none",
  "maxHeight": "100vh",
  "@media (min-width: 1024px)": {
    "display": "block",
    "height": "40rem"
  },
  "@media (min-width: 1280px)": {
    "height": "50rem"
  }
});
;// CONCATENATED MODULE: ./components/molecules/PdfViewer/index.tsx



var PdfViewer = function PdfViewer(_ref) {
  var path = _ref.path;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedEmbed, {
    src: path,
    type: 'application/pdf'
  });
};
;// CONCATENATED MODULE: ./components/molecules/Mdx/components.tsx






var hr = function hr() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: 'hr',
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(styled/* HorizontalBreak */.f, {})
  });
};

var components = {
  ContentBanner: ContentBanner,
  hr: hr,
  PdfViewer: PdfViewer
};

/***/ }),

/***/ 3649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ HorizontalBreak; },
/* harmony export */   "r": function() { return /* binding */ WWW_MDX_OVERRIDE_STYLES; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1895);
/* harmony import */ var _ColoredBorderWrapper_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3419);



var HorizontalBreak = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].hr.withConfig */ .ZP.hr.withConfig({
  displayName: "styled__HorizontalBreak",
  componentId: "sc-fikjku-0"
})(["", " ", ""], _ColoredBorderWrapper_styled__WEBPACK_IMPORTED_MODULE_0__/* .gradientBackground */ .P, {
  "height": "0.125rem",
  "borderWidth": "0px"
});
var WWW_MDX_OVERRIDE_STYLES = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["a{", "}"], {
  "--tw-text-opacity": "1",
  "color": "rgb(0 151 137 / var(--tw-text-opacity))",
  ".dark &": {
    "--tw-text-opacity": "1",
    "color": "rgb(65 205 127 / var(--tw-text-opacity))"
  }
});

/***/ }),

/***/ 6751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ Shell; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
;// CONCATENATED MODULE: ./components/molecules/NavBar/styled.ts

var styled_NavBar = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "styled__NavBar",
  componentId: "sc-1pq2k3n-0"
})(["", " > div{", "}a{", "}"], {
  "position": "sticky",
  "zIndex": "10",
  "display": "grid",
  "width": "100%",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(0 0 0 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "opacity": "0.95",
  "gridTemplateRows": "72px",
  "top": "0",
  "height": "72px",
  "@media (min-width: 1024px)": {
    "scrollSnapAlign": "start"
  }
}, {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "@media (min-width: 1024px)": {
    "paddingLeft": "2.5rem",
    "paddingRight": "2.5rem"
  }
}, {
  "textDecorationLine": "none"
});
var Logo = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "styled__Logo",
  componentId: "sc-1pq2k3n-1"
})(["", " svg{", " path{fill:url('#custodia-mark_svg__a');}}span{", "}"], {
  "display": "flex",
  "alignItems": "center",
  "fontSize": "2.25rem",
  "lineHeight": "2.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
}, {
  "height": "2.5rem"
}, {
  "marginLeft": "0.5rem",
  "fontWeight": "700"
});
var NavItemTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__NavItemTitle",
  componentId: "sc-1pq2k3n-2"
})(function (_ref) {
  var isSelected = _ref.isSelected;
  return [{
    "paddingLeft": "0.75rem",
    "paddingRight": "0.75rem",
    "paddingTop": "0.25rem",
    "paddingBottom": "0.25rem",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))",
    ":hover": {
      "opacity": "0.7"
    }
  }, isSelected && {
    "fontWeight": "700"
  }];
});
var DesktopRightContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__DesktopRightContent",
  componentId: "sc-1pq2k3n-3"
})(["", ""], {
  "display": "flex"
});
var DesktopNavItems = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styled__DesktopNavItems",
  componentId: "sc-1pq2k3n-4"
})(["", ""], {
  "display": "none",
  "listStyleType": "none",
  "gridTemplateColumns": "repeat(3, auto)",
  "alignItems": "center",
  "gap": "3rem",
  "fontSize": "1.25rem",
  "lineHeight": "1.75rem",
  "@media (min-width: 1024px)": {
    "display": "grid"
  }
});
var MobileNavItems = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styled__MobileNavItems",
  componentId: "sc-1pq2k3n-5"
})(function (_ref2) {
  var menuOpen = _ref2.menuOpen;
  return [{
    "display": "none",
    "listStyleType": "none",
    "alignItems": "center",
    "paddingLeft": "0.5rem",
    "paddingRight": "0.5rem",
    "paddingTop": "1rem",
    "paddingBottom": "1rem",
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem",
    "marginTop": "-0.1rem"
  }, {
    "position": "sticky",
    "left": "0px",
    "zIndex": "10",
    "height": "calc(100vh - 72px + 0.1rem)",
    "width": "100%",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(0 0 0 / var(--tw-bg-opacity))",
    "top": "72px"
  }, menuOpen && {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "gap": "1.75rem",
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem",
    "@media (min-width: 1024px)": {
      "display": "none"
    }
  }];
});
var MobileMenuSpacer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__MobileMenuSpacer",
  componentId: "sc-1pq2k3n-6"
})(["", ""], {
  "width": "100%",
  "flexGrow": "1"
});
var MobileSubscribeButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__MobileSubscribeButtonWrapper",
  componentId: "sc-1pq2k3n-7"
})(["", " button{", "}"], {
  "width": "100%",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "paddingBottom": "1rem"
}, {
  "display": "block",
  "width": "100%"
});
var DarkModeButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styled__DarkModeButton",
  componentId: "sc-1pq2k3n-8"
})(["", ""], {
  "marginLeft": "1.5rem",
  "display": "none",
  "@media (min-width: 1024px)": {
    "display": "block"
  }
});
var MenuButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styled__MenuButton",
  componentId: "sc-1pq2k3n-9"
})(["", ""], {
  "padding": "0.25rem",
  "@media (min-width: 1024px)": {
    "display": "none"
  }
});
// EXTERNAL MODULE: ../../node_modules/react-icons/vsc/index.mjs
var vsc = __webpack_require__(8097);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./assets/custodia-mark.svg
var custodia_mark = __webpack_require__(5426);
// EXTERNAL MODULE: ./components/molecules/ColoredBorderWrapper/styled.ts
var styled = __webpack_require__(3419);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/molecules/ColoredBorderWrapper/index.tsx




var ColoredBorderWrapper = function ColoredBorderWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [children, /*#__PURE__*/(0,jsx_runtime.jsx)(styled/* Border */.O, {})]
  });
};
;// CONCATENATED MODULE: ./components/molecules/NavBar/index.tsx









var ROUTES = [{
  title: 'Avit',
  href: '/avit'
}, {
  title: 'Press',
  href: '/press'
}, {
  title: 'About',
  href: '/about'
}];
var NavBar = function NavBar() {
  var _useState = (0,react.useState)(false),
      menuOpen = _useState[0],
      setMenuOpen = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styled_NavBar, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: '/',
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Logo, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(custodia_mark/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "Custodia"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopRightContent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MenuButton, {
          onClick: function onClick() {
            return setMenuOpen(!menuOpen);
          },
          "aria-expanded": !!menuOpen,
          "aria-label": "Menu",
          "aria-controls": "nav-menu",
          children: menuOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)(vsc/* VscClose */.ven, {
            size: 25
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(vsc/* VscThreeBars */.QEj, {
            size: 25
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DesktopNavItems, {
          children: ROUTES.map(function (r) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(NavItem, {
              href: r.href,
              title: r.title
            }, r.href);
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MobileNavItems, {
      menuOpen: menuOpen,
      id: 'nav-menu',
      children: [ROUTES.map(function (r) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(NavItem, {
          href: r.href,
          title: r.title
        }, r.href);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MobileMenuSpacer, {})]
    })]
  });
};

var NavItem = function NavItem(_ref) {
  var href = _ref.href,
      title = _ref.title,
      external = _ref.external;
  var router = (0,next_router.useRouter)();
  var isCurrentRoute = !external && (router.route === href || // highlight "Avit" on /avit and any nested page (e.g. the redemption page)
  href === '/avit' && router.route.startsWith('/avit/'));

  var content = /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    children: isCurrentRoute ? /*#__PURE__*/(0,jsx_runtime.jsx)(ColoredBorderWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavItemTitle, {
        isSelected: isCurrentRoute,
        children: title
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(NavItemTitle, {
      isSelected: isCurrentRoute,
      children: title
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    children: external ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: href,
      children: content
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: href,
      children: content
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(2779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/design-system/footer/index.ts + 3 modules
var footer = __webpack_require__(2890);
// EXTERNAL MODULE: ./components/molecules/Shell/styled.ts
var Shell_styled = __webpack_require__(564);
// EXTERNAL MODULE: ./hooks/useIsBrowser.ts
var useIsBrowser = __webpack_require__(9612);
// EXTERNAL MODULE: ../../packages/design-system/cookie-banner/index.tsx + 4 modules
var cookie_banner = __webpack_require__(86);
;// CONCATENATED MODULE: ./components/molecules/Shell/index.tsx










var Shell = function Shell(_ref) {
  var _ref$enableSnapPoints = _ref.enableSnapPoints,
      enableSnapPoints = _ref$enableSnapPoints === void 0 ? false : _ref$enableSnapPoints,
      children = _ref.children;
  var isBrowser = (0,useIsBrowser/* useIsBrowser */.E)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Shell_styled/* ShellWrapper */.r, {
      className: classnames_default()({
        dark: true
      }),
      enableSnapPoints: enableSnapPoints,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Shell_styled/* ContentWrapper */.v, {
        children: children
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(footer/* default */.ZP, {}), isBrowser && /*#__PURE__*/(0,jsx_runtime.jsx)(cookie_banner/* default */.Z, {})]
    })
  });
};

/***/ }),

/***/ 2351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ BASE_MDX_WRAPPER_STYLES; },
/* harmony export */   "i": function() { return /* binding */ Wrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1895);

var BASE_MDX_WRAPPER_STYLES = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(["", " li{", " p:not(:first-child){", "}}h1{", "}h2{", "}h3{", "}h4{", "}h5{", "}h6{", "}a{", "}ul,ol{", "}ol{", "}ul{", "}"], {
  "display": "flex",
  "flexDirection": "column",
  "gap": "1.25rem",
  "fontSize": "1.125rem",
  "lineHeight": "1.75rem"
}, {
  "paddingTop": "0.25rem",
  "paddingBottom": "0.25rem"
}, {
  "paddingTop": "0.5rem"
}, {
  "fontSize": "1.875rem",
  "lineHeight": "2.25rem",
  "@media (min-width: 768px)": {
    "fontSize": "3rem",
    "lineHeight": "1"
  }
}, {
  "fontSize": "1.5rem",
  "lineHeight": "2rem",
  "@media (min-width: 768px)": {
    "fontSize": "2.25rem",
    "lineHeight": "2.5rem"
  }
}, {
  "fontSize": "1.25rem",
  "lineHeight": "1.75rem",
  "@media (min-width: 768px)": {
    "fontSize": "1.875rem",
    "lineHeight": "2.25rem"
  }
}, {
  "fontSize": "1.125rem",
  "lineHeight": "1.75rem",
  "@media (min-width: 768px)": {
    "fontSize": "1.5rem",
    "lineHeight": "2rem"
  }
}, {
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "@media (min-width: 768px)": {
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem"
  }
}, {
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "@media (min-width: 768px)": {
    "fontSize": "1.125rem",
    "lineHeight": "1.75rem"
  }
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(65 205 127 / var(--tw-text-opacity))",
  "textDecorationLine": "none"
}, {
  "listStylePosition": "outside",
  "paddingLeft": "1.5rem"
}, {
  "listStyleType": "decimal"
}, {
  "listStyleType": "disc"
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "sc-1w2is1l-0"
})(["", " ", ""], BASE_MDX_WRAPPER_STYLES, function (_ref) {
  var styles = _ref.styles;
  return styles !== null && styles !== void 0 ? styles : '';
});

/***/ }),

/***/ 4423:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: MPL-2.0
 */

/**
 * Allow jsx-runtime to be successfully imported from either React 17 or React 18.
 *
 * Inspired by the approach here: https://github.com/contentlayerdev/contentlayer/blob/main/packages/next-contentlayer/src/hooks/jsx-runtime.cjs
 */
if (false) {} else {
  module.exports.jsxRuntime = __webpack_require__(2322)
}


/***/ }),

/***/ 2154:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* reexport */ MDXRemote; }
});

// NAMESPACE OBJECT: ../../node_modules/@mdx-js/react/index.js
var _mdx_js_react_namespaceObject = {};
__webpack_require__.r(_mdx_js_react_namespaceObject);
__webpack_require__.d(_mdx_js_react_namespaceObject, {
  "MDXContext": function() { return MDXContext; },
  "MDXProvider": function() { return MDXProvider; },
  "useMDXComponents": function() { return useMDXComponents; },
  "withMDXComponents": function() { return withMDXComponents; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next-mdx-remote/dist/jsx-runtime.cjs
var jsx_runtime = __webpack_require__(4423);
;// CONCATENATED MODULE: ../../node_modules/@mdx-js/react/lib/index.js
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('mdx/types.js').MDXComponents} Components
 *
 * @typedef Props
 *   Configuration.
 * @property {Components | MergeComponents | null | undefined} [components]
 *   Mapping of names for JSX components to React components.
 * @property {boolean | null | undefined} [disableParentContext=false]
 *   Turn off outer component context.
 * @property {ReactNode | null | undefined} [children]
 *   Children.
 *
 * @callback MergeComponents
 *   Custom merge function.
 * @param {Components} currentComponents
 *   Current components from the context.
 * @returns {Components}
 *   Merged components.
 */



/**
 * @type {import('react').Context<Components>}
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components and
 *   `MDXProvider` to set context based components instead.
 */
const MDXContext = react.createContext({})

/**
 * @param {import('react').ComponentType<any>} Component
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components instead.
 */
function withMDXComponents(Component) {
  return boundMDXComponent

  /**
   * @param {Record<string, unknown> & {components?: Components | null | undefined}} props
   * @returns {JSX.Element}
   */
  function boundMDXComponent(props) {
    const allComponents = useMDXComponents(props.components)
    return react.createElement(Component, {...props, allComponents})
  }
}

/**
 * Get current components from the MDX Context.
 *
 * @param {Components | MergeComponents | null | undefined} [components]
 *   Additional components to use or a function that takes the current
 *   components and filters/merges/changes them.
 * @returns {Components}
 *   Current components.
 */
function useMDXComponents(components) {
  const contextComponents = react.useContext(MDXContext)

  // Memoize to avoid unnecessary top-level context changes
  return react.useMemo(() => {
    // Custom merge via a function prop
    if (typeof components === 'function') {
      return components(contextComponents)
    }

    return {...contextComponents, ...components}
  }, [contextComponents, components])
}

/** @type {Components} */
const emptyObject = {}

/**
 * Provider for MDX context
 *
 * @param {Props} props
 * @returns {JSX.Element}
 */
function MDXProvider({components, children, disableParentContext}) {
  /** @type {Components} */
  let allComponents

  if (disableParentContext) {
    allComponents =
      typeof components === 'function'
        ? components({})
        : components || emptyObject
  } else {
    allComponents = useMDXComponents(components)
  }

  return react.createElement(
    MDXContext.Provider,
    {value: allComponents},
    children
  )
}

;// CONCATENATED MODULE: ../../node_modules/@mdx-js/react/index.js


;// CONCATENATED MODULE: ../../node_modules/next-mdx-remote/dist/index.js




/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: MPL-2.0
 */

if (typeof window !== 'undefined') {
  window.requestIdleCallback =
    window.requestIdleCallback ||
    function (cb) {
      var start = Date.now();
      return setTimeout(function () {
        cb({
          didTimeout: false,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - start))
          },
        });
      }, 1)
    };

  window.cancelIdleCallback =
    window.cancelIdleCallback ||
    function (id) {
      clearTimeout(id);
    };
}

/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: MPL-2.0
 */
/**
 * Renders compiled source from next-mdx-remote/serialize.
 */
function MDXRemote({ compiledSource, frontmatter, scope, components = {}, lazy, }) {
    const [isReadyToRender, setIsReadyToRender] = (0,react.useState)(!lazy || typeof window === 'undefined');
    // if we're on the client side and `lazy` is set to true, we hydrate the
    // mdx content inside requestIdleCallback, allowing the page to get to
    // interactive quicker, but the mdx content to hydrate slower.
    (0,react.useEffect)(() => {
        if (lazy) {
            const handle = window.requestIdleCallback(() => {
                setIsReadyToRender(true);
            });
            return () => window.cancelIdleCallback(handle);
        }
    }, []);
    const Content = (0,react.useMemo)(() => {
        // if we're ready to render, we can assemble the component tree and let React do its thing
        // first we set up the scope which has to include the mdx custom
        // create element function as well as any components we're using
        const fullScope = Object.assign({ opts: { ..._mdx_js_react_namespaceObject, ...jsx_runtime.jsxRuntime } }, { frontmatter }, scope);
        const keys = Object.keys(fullScope);
        const values = Object.values(fullScope);
        // now we eval the source code using a function constructor
        // in order for this to work we need to have React, the mdx createElement,
        // and all our components in scope for the function, which is the case here
        // we pass the names (via keys) in as the function's args, and execute the
        // function with the actual values.
        const hydrateFn = Reflect.construct(Function, keys.concat(`${compiledSource}`));
        return hydrateFn.apply(hydrateFn, values).default;
    }, [scope, compiledSource]);
    if (!isReadyToRender) {
        // If we're not ready to render, return an empty div to preserve SSR'd markup
        return (react.createElement("div", { dangerouslySetInnerHTML: { __html: '' }, suppressHydrationWarning: true }));
    }
    // wrapping the content with MDXProvider will allow us to customize the standard
    // markdown components (such as "h1" or "a") with the "components" object
    const content = (react.createElement(MDXProvider, { components: components },
        react.createElement(Content, null)));
    // If lazy = true, we need to render a wrapping div to preserve the same markup structure that was SSR'd
    return lazy ? react.createElement("div", null, content) : content;
}



;// CONCATENATED MODULE: ../../node_modules/next-mdx-remote/index.js
/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: MPL-2.0
 */




/***/ })

}]);